package hk.com.vr360_demo2.webapp.core.net

import hk.com.vr360_demo2.webapp.core.net.common.ResponseInfo
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.statement.HttpResponse
import io.ktor.http.isSuccess
import io.ktor.util.reflect.typeInfo
import kotlinx.coroutines.Dispatchers

import kotlinx.coroutines.withContext

sealed interface ApiResponse<T> {
    data class Success<T>(val data: T) : ApiResponse<T>
    data class Error<T>(val msg: String?, val data: T?) : ApiResponse<T>
}

suspend inline fun <reified Data> httpRequest(
    ktorClient: HttpClient,
    crossinline request: suspend HttpClient.() -> HttpResponse,
): ApiResponse<Data> = withContext(Dispatchers.Default) {
    try {
        val response = request(ktorClient)
        if (response.status.isSuccess()) {
            ApiResponse.Success(response.body(typeInfo<Data>()))
        } else {
            ApiResponse.Error(response.status.description, response.body())
        }
    } catch (exception: Throwable) {
        exception.printStackTrace()
        ApiResponse.Error("網絡異常", null)
//        ApiResponse.Error(exception.message?.takeIf { it.isNotBlank() }, null)
    }
}


inline fun <T, Action> ApiResponse<ResponseInfo<T>>.fold(
    onError: (Exception) -> Action,
    onSuccess: (ResponseInfo<T>) -> Action
): Action = when (this) {
    is ApiResponse.Error -> onError(Exception(msg?.takeIf { it.isNotBlank() } ?: "伺服器或網路異常"))
    is ApiResponse.Success -> {
        if (data.isSuccess()) {
            onSuccess(data)
        } else {
            BusinessErrorHandler.handleError(data)
            onError(ServiceException(data.code, data.msg))
        }
    }
}

fun <T> ApiResponse<ResponseInfo<T>>.isSuccess(): Boolean {
    return this is ApiResponse.Success && !data.isSuccess()
}

inline fun <T> ApiResponse<ResponseInfo<T>>.onSuccess(action: (value: ResponseInfo<T>) -> Unit): ApiResponse<ResponseInfo<T>> {
    if (this is ApiResponse.Success) {
        if (data.isSuccess()) {
            action(this.data)
        }
    }
    return this
}

inline fun <T> ApiResponse<ResponseInfo<T>>.onFailure(action: (value: Exception) -> Unit): ApiResponse<ResponseInfo<T>> {
    when (this) {
        is ApiResponse.Error -> action(Exception("服務器或網絡異常"))
        is ApiResponse.Success -> {
            if (!data.isSuccess()) {
                BusinessErrorHandler.handleError(data)
                action(ServiceException(data.code, data.msg))
            }
        }
    }
    return this
}